import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { fetchMarkerCategories } from "./thunk";
import { hydrate } from "@/lib";
import type { ResponsePayload } from "@/types";

type Marker = {
  name: string;
  icon: string;
  visible: boolean;
  answered: boolean;
  id: string;
};
type MarkerCategory = {
  categories: Array<Marker>;
  status: "idle" | "fetching";
  error: string;
};

const initialState: MarkerCategory = {
  categories: [],
  status: "idle",
  error: ""
};
export const markerCategoriesSlice = createSlice({
  name: "markerCategories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => ({
        ...state,
        ...action.payload[markerCategoriesSlice.name]
      }))
      .addCase(fetchMarkerCategories.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchMarkerCategories.fulfilled, (state, action) => {
        state.categories = action.payload;
        state.status = "idle";
      })
      .addCase(fetchMarkerCategories.rejected, (state, action) => {
        const { statusText } = action.payload as ResponsePayload;

        state.status = "idle";
        state.error = statusText;
      });
  }
});
